var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control-label mt-3"},[(_vm.label)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.label)+":")])]):_vm._e(),_c('vue-editor',{staticClass:"mb-3",attrs:{"disabled":_vm.disabled},on:{"text-change":_vm.updateValue},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }